import { PermissionType } from '@/auth/permission';
import { authMod } from '@/store/modules/auth';

export function hasAnyPermissions(permToCheck: PermissionType[]): boolean {
  if (authMod.getPermissions) {
    return permToCheck.some((permission) => authMod.getPermissions.includes(permission));
  }
  return false;
}

export function hasAllPermissions(permToCheck: PermissionType[]): boolean {
  if (authMod.getPermissions) {
    return permToCheck.every((permission) => authMod.getPermissions.includes(permission));
  }
  return false;
}
